import React from 'react';
import {NEWS} from '../../shared/NewsData'
import {Row,Col, Container,Card, CardBody, CardText } from 'reactstrap';
import manoranjan from '../../images/manoranjan.jpg';
function Post({post})
{
    return(
        <Card className='border-0 shadow mt-20'style={{width: '70%', marginLeft: 'auto', marginRight: 'auto'}}>
            <CardBody>
                <Row>
                <Col xs={10} className='text-center pt-4'>
                <h2>{post.date}</h2>
                <CardText>
                    <p>{post.content}</p>
                </CardText>
                </Col>
                <Col>
                <img src={post.img} height={100} width={100}/>
                </Col>
                </Row>
            </CardBody>

        </Card>

    );
}
export default function NewsFeed()
{
    return(
        <div>
            <Container className='mt-3'>
            {NEWS.map((post)=>{return(
            <Post post= {post} />
            );
            })}
            </Container>
        </div>
    )
}